import * as UI from "@accurx/design";
import { Ds } from "@accurx/design";
import styled from "styled-components";

const OrderedList = styled.ol`
    margin-left: -1rem;
`;

export const ErrorFetchingCurrentPatientFeedback = () => {
    return (
        <UI.Feedback
            title="No connection to medical system"
            colour="information"
            iconName="Info"
        >
            <Ds.Text>To connect, follow these steps:</Ds.Text>

            <OrderedList>
                <Ds.Text as="li">
                    Click your initials in the toolbar and select 'Exit'.
                </Ds.Text>
                <Ds.Text as="li">
                    Restart Accurx from the desktop icon or start menu. After
                    launching, don&apos;t click anything — your initials should
                    turn red or orange.
                </Ds.Text>
                <Ds.Text as="li">
                    Follow this guide to get connected:{" "}
                    <Ds.Link
                        color="blue"
                        target="_blank"
                        href="https://support.accurx.com/en/articles/2743730-accurx-desktop-how-to-add-a-new-user"
                    >
                        Set up Accurx Desktop
                    </Ds.Link>
                </Ds.Text>
                <Ds.Text as="li">
                    Need help? Contact support at support@accurx.com
                </Ds.Text>
            </OrderedList>
        </UI.Feedback>
    );
};
